export default __webpack_public_path__ + "static/media/1329.bec85dbb.png";